export default function fixContrastUsingSimpleMethod(colorLab: number[], baseLValue: number) {
    // Flipped and scaled L value because baseLValue reduced the range from [0, 100] to [baseLValue, 100]
    return (100 - colorLab[0]) * ((100 - baseLValue) / 100) + baseLValue;
}
